import apiClient from './apiClient';

export const notificationsAPI = {
  list: () => apiClient.get('/notifications/notifications/'),
  unread: () => apiClient.get('/notifications/notifications/unread/'),
  markRead: (id) => apiClient.post(`/notifications/notifications/${id}/mark_read/`),
};
